import EmptyRecords from '@/views/components/Common/EmptyRecords';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import ContentSpinner from '@/views/components/Spinners/ContentSpinner';

import { useGetClaimEmailStatus } from '../hooks';
import LADEmailStatusCard from './LADEmailStatusCard';

const LADEmailStatus = ({ claimKey }) => {
  const { data: emailStatusData, isFetching } = useGetClaimEmailStatus(claimKey);
  const data = emailStatusData?.claimEmails || [];

  return (
    <div className="h-100 overflow-hidden">
      {isFetching ? (
        <ContentSpinner size="large" className="h-100" />
      ) : (
        <ScrollPagination className="h-100">
          {data?.length > 0 ? (
            data.map((item, index) => {
              // biome-ignore lint/suspicious/noArrayIndexKey: static
              return <LADEmailStatusCard key={index} data={item} />;
            })
          ) : (
            <EmptyRecords title="There is no email records found!" descriptionOne="" descriptionTwo="" />
          )}
        </ScrollPagination>
      )}
    </div>
  );
};

export default LADEmailStatus;
